
export const SSO_REDIRECT_URL_PATH = '/auth-redirect/sso'

export const LANDING_ROUTE_STORAGE_KEY = 'applicationLandingRoute'
